import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import useTrans from '../../../../../hooks/useTrans'
import { api } from '../../../../../utils'
import { CANALECOMMERCIALE } from '../../../../../utils/endpoint'
import Button from '../../../../atoms/Button/Button'
import FormField from '../../../../atoms/FormField/FormField'
import FormSelect from '../../../../atoms/FormSelect/FormSelect'
import { trackingRegistrazioneFunnel } from '../../../../../utils/gtm'

const InfoAggiuntive = ({ step, setStep, props }) => {
  const t = useTrans()
  const [canali, setCanali] = useState()
  const [sottoCanali, setSottoCanali] = useState(null)

  const router = useRouter()
  useEffect( () => {
    const params = {
      lang: router.locale,
    }
     api
      .get(CANALECOMMERCIALE, params)
      .then((data) => setCanali(data.data))
      .catch((error) => console.log(error))
  }, [])

  return (
    <div className="step-registrazione">
      <div className="step-registrazione__fieldsets">
        <FormField
          label={t('Come hai conosciuto sipec S.p.A*? ')}
          id={'info-aggiuntive-canale-commerciale'}
        >
          <FormSelect
            placeholder={t("Seleziona un'opzione")}
            options={
              canali
                ? canali.map((canale) => {
                    return {
                      label: canale.descrizione,
                      value: canale.id,
                    }
                  })
                : []
            }
            value={props.values.info_aggiuntive?.canale_commerciale_id}
            onChange={(e) => {
              const selectedCanaleId = e.target.value
              const sottoCanali = canali?.find((canale) => canale.id === selectedCanaleId)
                ?.sottocanale_commerciale
              setSottoCanali(sottoCanali)
              props.setFieldValue('info_aggiuntive.canale_commerciale_id', selectedCanaleId)
              props.setFieldValue('info_aggiuntive.sottocanale_commerciale_id', undefined)
            }}
            id={'info-aggiuntive-canale-commerciale'}
          ></FormSelect>
        </FormField>
        <FormField
          label={t('nello specifico*')}
          status={
            props.touched.info_aggiuntive?.sottocanale_commerciale_id &&
            props.errors.info_aggiuntive?.sottocanale_commerciale_id
              ? 'error'
              : props.touched.info_aggiuntive?.sottocanale_commerciale_id && 'success'
          }
          errorMessage={props.errors?.info_aggiuntive?.sottocanale_commerciale_id}
          id={'info-aggiuntive-sottocanale-commerciale'}
        >
          <FormSelect
            placeholder={t("Seleziona un'opzione")}
            options={
              sottoCanali
                ? sottoCanali.map((sottocanale) => {
                    return {
                      label: sottocanale.descrizione,
                      value: sottocanale.id,
                    }
                  })
                : []
            }
            value={props.values.info_aggiuntive?.sottocanale_commerciale_id}
            onChange={(e) =>
              props.setFieldValue('info_aggiuntive.sottocanale_commerciale_id', e.target.value)
            }
            onBlur={props.handleBlur('info_aggiuntive.sottocanale_commerciale_id')}
            id={'info-aggiuntive-sottocanale-commerciale'}
          ></FormSelect>
        </FormField>
      </div>

      <p className="step-registrazione__legend">{t('*Campi obbligatori')}</p>
      <Button
        disabled={
          props.values?.info_aggiuntive?.sottocanale_commerciale_id ? false : true || !props.dirty
        }
        label={t('Conferma dati')}
        variant="primary"
        size="medium"
        onClick={() => {
          trackingRegistrazioneFunnel(4)
          setStep(step + 1)
        }}
      />
    </div>
  )
}

export default InfoAggiuntive
